import { LabelProps, Label } from './Label';
export function LabelDisplay2(props: LabelProps) {
    return (
        <Label
            color="text-dark-red"
            variant="text-mobile-display-2"
            {...props}
        />
    );
}
